/**
 * @return {JSX.Element} Серый горизонтальный разделитель, заполняющий собой всю ширину
 *
 * @param {import('react').HTMLAttributes<HTMLDivElement>} props
 * */
export default function HorizontalDivider({ ...divProps }) {
  return <span className="h-[2px] w-full bg-gray-200 rounded" {...divProps} />;
}
